import React from 'react'
import PropTypes from 'prop-types'

/** Icon dấu trừ tại màn hình detai_food*/
const SubtractIconTab = ({ size = '65px', color = 'black' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 71 71"
      fill="none">
      <path d="M48.5605 35.2573H21.9548" stroke="black" strokeWidth="3" strokeLinecap="round" />
      <path
        d="M35.2571 68.5143C53.6246 68.5143 68.5143 53.6246 68.5143 35.2571C68.5143 16.8897 53.6246 2 35.2571 2C16.8897 2 2 16.8897 2 35.2571C2 53.6246 16.8897 68.5143 35.2571 68.5143Z"
        stroke={color}
        strokeWidth="3"
      />
    </svg>
  )
}

export default React.memo(SubtractIconTab)
SubtractIconTab.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
}
